<template>
    <div v-if="isVisible" :class="[
            'form-item', item.data.inputtype, item.data.htmloptions,
            { 'is-invalid' : isInvalid, 'is-filled' : internalValue != '' }
        ]">

        <span v-if="item.data.description != ''" class="description">{{  item.data.description }}</span>

        <div class="input-wrapper" v-if="item.data.inputtype === 'textarea'">
            <textarea
                :id="item.data.id"
                :name="item.data.id"
                :maxlength="item.data.inputmaxlength"
                :readonly="item.data.readonly"
                :disabled="item.data.disabled"
                v-model="internalValue"
                :placeholder="item.data.placeholder ? item.data.placeholder : ' '"
                @input="updateFormValue(item.data.uniqlabel, $event.target.value)">
            </textarea>
                <Label
                    :item="item"
                    :is-invalid="isInvalid"
                    :error-message="errorMessage"
                />
        </div>

        <div class="input-wrapper" v-else-if="item.data.inputtype === 'date'">
            <v-date-picker
                v-model="internalValue"
                readonly="readonly"
                :popover="{
                    visibility: 'focus'
                }"
                :locale="locale"
                @input="date => updateFormValue(item.data.uniqlabel, date)"
            >
                <template #default="{ inputValue, inputEvents }">
                    <div class="template-root">
                        <input
                            type="hidden"
                            :placeholder="item.data.placeholder"
                            readonly="readonly"
                            :name="item.data.id"
                            :value="dateFormatted(inputValue)"
                            v-on="inputEvents">
                        <input
                            :type="'text'"
                            :placeholder="item.data.placeholder"
                            readonly="readonly"
                            :value="inputValue"
                            v-on="inputEvents">
                        <Label
                            :item="item"
                            :is-invalid="isInvalid"
                            :error-message="errorMessage"
                        />
                    </div>
                </template>
            </v-date-picker>

            <i class="icon-form-datepicker"></i>
        </div>

        <div class="input-wrapper" v-else-if="item.data.inputtype === 'time'">
            <v-date-picker
                v-model="internalValue"
                mode="time"
                :is24hr="true"
                :minute-increment="5"
                :locale="locale"
                readonly="readonly"
                :popover="{
                    visibility: 'focus'
                }"
                @input="date => updateFormValue(item.data.uniqlabel, date)"
                >
                <template #default="{ inputValue, inputEvents }">
                    <div class="template-root">
                        <input
                            :type="'text'"
                            :placeholder="item.data.placeholder"
                            readonly="readonly"
                            :name="item.data.id"
                            :value="inputValue"
                            v-on="inputEvents">
                        <Label
                            :item="item"
                            :is-invalid="isInvalid"
                            :error-message="errorMessage"
                        />
                    </div>
                </template>
            </v-date-picker>
        </div>

        <div class="input-wrapper" v-else-if="item.data.inputtype === 'number'">
            <input
                :id="item.data.id"
                v-model="internalValue"
                :type="item.data.inputtype"
                :disabled="item.data.disabled"
                :name="item.data.id"
                :placeholder="item.data.placeholder"
                :min="item.data.inputnumbermin"
                :max="item.data.inputnumbermax"
                @input="updateFormValue(item.data.uniqlabel, $event.target.value)">
            <Label
                :item="item"
                :is-invalid="isInvalid"
                :error-message="errorMessage"
            />
        </div>

        <div class="input-wrapper" v-else-if="item.data.inputtype === 'color'">
            <div class="d-flex align-items-center justify-content-center">
                <div class="flex-grow-1 mr-2">
                    <input
                        v-model="color"
                        readonly
                        :placeholder="item.data.placeholder">
                    <Label
                        :item="item"
                        :is-invalid="isInvalid"
                        :error-message="errorMessage"

                    />
                </div>
                <vue-swatches
                    v-model="color"
                    popover-x="right"
                    show-fallback
                    fallback-input-type="color"
                    :inline="false" />
            </div>
        </div>

        <div class="input-wrapper" v-else-if="item.data.inputtype === 'range'">
            <Label
                :item="item"
                :error-message="errorMessage"
                :is-invalid="isInvalid"
            />
            <input
                :id="item.data.id"
                v-model="internalValue"
                :type="item.data.inputtype"
                :disabled="item.data.disabled"
                :readonly="item.data.readonly"
                :name="item.data.id"
                :placeholder="item.data.placeholder"
                :min="item.data.inputslidermin"
                :max="item.data.inputslidermax"
                :step="item.data.inputslidersteps"
                @input="updateFormValue(item.data.uniqlabel, $event.target.value)">
        </div>

        <div class="input-wrapper" v-else-if="item.data.inputtype === 'hidden'">
            <input
                :id="item.data.id"
                v-model="internalValue"
                :type="item.data.inputtype"
                :name="item.data.id"
                @input="updateFormValue(item.data.uniqlabel, $event.target.value)">
        </div>

        <div class="input-wrapper" v-else-if="item.data.inputtype === 'password'">
            <input
                :id="item.data.id"
                v-model="internalValue"
                :type="passwordFieldType"
                :disabled="item.data.disabled"
                :name="item.data.id"
                :placeholder="item.data.placeholder ? item.data.placeholder : ' '"
                :maxlength="item.data.inputtype === 'text' ? item.data.inputmaxlength : false"
                @input="updateFormValue(item.data.uniqlabel, $event.target.value)">
            <Label
                :item="item"
                :is-invalid="isInvalid"
                :error-message="errorMessage"
            />
            <i class="password-icon"
                :class="[ showPassword ? 'icon-form-show' : 'icon-form-hide']"
                @click="toggleShowPassword"></i>
        </div>

        <div class="input-wrapper" v-else>
            <input
                :id="item.data.id"
                v-model="internalValue"
                :type="item.data.inputtype"
                :name="item.data.id"
                :disabled="item.data.disabled"
                :placeholder="item.data.placeholder ? item.data.placeholder : ' '"
                :maxlength="item.data.inputtype === 'text' ? item.data.inputmaxlength : false"
                @input="updateFormValue(item.data.uniqlabel, $event.target.value)"
                >
            <Label
                :item="item"
                :is-invalid="isInvalid"
                :error-message="errorMessage"
            />
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import VCalendar from 'v-calendar';
import VueSwatches from "vue-swatches";
import Label from "../components/Label.vue";
import 'vue-swatches/dist/vue-swatches.css';

import errorMixin from "../mixins/error";
import logicMixin from "../mixins/logic";

Vue.use(VCalendar, {
    componentPrefix: 'v',
    attributes: [{
        popover: {
            visibility: 'focus'
        }
    }]
});

export default {
    name: 'Input',
    components: {
        Label,
        VueSwatches
    },
    mixins: [ errorMixin, logicMixin ],
    props: {
        value: {
            type: String,
            default: ''
        },
        item: {
            type: Object
        },
        formValues: {
            type: Object
        }
    },
    data: function() {
        return {
            date: '',
            color: '',
            showPassword: false
        };
    },
    methods: {
        updateFormValue(ident, value) {
            this.$emit('update-form-value', ident, value)
        },
        toggleShowPassword() {
            this.showPassword = !this.showPassword;
        },
        dateFormatted () {
            if (!this.internalValue) {
                return ''
            }
            const offset = this.internalValue.getTimezoneOffset()
            const yourDate = new Date(this.internalValue.getTime() - (offset*60*1000))
            return yourDate.toISOString().split('T')[0]
        }
    },
    computed: {
        passwordFieldType() {
            return this.showPassword ? 'text' : 'password';
        },
        locale() {
            return document.documentElement.lang;
        },
        internalValue: {
            get () {
                return Object.keys(this.formValues).length ? this.formValues[this.item.data.uniqlabel] : this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.vue-swatches {
    height: 42px;
}
</style>